<div class="float-left bg-white card-background">
  <form [formGroup]="userForm" autocomplete="off" role="form" class="fieldHeight">
    <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='!editMode' (onBackClickHandler)="OnBackClick()"></app-content-top-nav>
    <div class="col-md-12 clear-all title-wrapper">
      <h1 class="title-text custom-header-h2" id="yourPensionSavings-header">{{contentData['header']}}</h1>
    </div>
    <div class="col-md-12 clear-all content-wrapper">
      <p class="content-top mt-0" id="yourPensionSavings-introduction">{{contentData['introduction']}}
      </p>
    </div>

    <app-question [childId]="'guarantees'" [questionConfig]="contentData['guaranteesQuestion']" [parent]="yourPensionForm" [controlName]="'guarantees'">
    </app-question>

    <app-question [childId]="'penalties'" [questionConfig]="contentData['penaltiesQuestion']" [parent]="yourPensionForm" [controlName]="'penalties'">
    </app-question>

    <div class="display-flex float-left form-group margint-30 content-wrapper">
      <p class="para-font" id="pension-pot-choice">{{contentData['pensionPotChoiceIntroStatement']}}</p>
      <app-tool-tip-notification [childId]="'pensionPotChoice'" class="statement-info" [tooltipName]="'pensionPotChoiceTooltip'"
        [tooltipData]="contentData['pensionPotChoiceInfo']">
      </app-tool-tip-notification>
    </div>

    <div class="sources-div col-xs-12">
      <app-pension-source class="pension-source-div" *ngFor="let sourceData of sourcesConfiguration"
        [sourceConfig]="sourceData.config" [parent]="yourPensionForm.get(sourceData.controlName)"
        [parentControlName]="sourceData.controlName" (currencyValueChanged)="updateTotalFund($event)"
        (productCodeChanged)="validateProductCode($event)" (onChangeHandler)="txtChange($event)">
      </app-pension-source>
      <div id="pensionPotError" class="col-xs-12 form-validation-error" *ngIf="pensionPotErrorValidatorFlag">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p id="noFund-error" aria-hidden="false" role="error">{{contentData.errorMessages.noFundErrorMessage}}</p>
      </div>
    </div>

    <p class="col-xs-12 total-fund">
      <span class="label" id="totalPension">{{contentData['totalPension']}}</span>
      <span class="amount" id="totalFund">{{totalFundAmount | currency :'GBP':'symbol':'1.2-2' }}</span>
    </p>

    <div *ngIf="manualSourceSelection">
      <div class="col-md-12 underline margin-top"></div>
      <app-question [childId]="'manualSource'" [questionConfig]="manualSourceConfig" [parent]="yourPensionForm" [controlName]="'manualSource'">
      </app-question>
    </div>

    <app-modal *ngIf="displayAlert" [modalConfig]="alertModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
    (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>
   
    <app-modal *ngIf="displayEditAlert" [modalConfig]="alertModalEditConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
    (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="false"></app-modal>

    <div class="col-md-12 underline margin-top"></div>
    <div class="col-md-12 clear-all">
      <div class="float-left">
        <app-save [location]="'contentBottom'"></app-save>
      </div>
      <div class="float-right">
        <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']" [buttonType]="'normalCTA'">
        </app-content-bottom-nav>
      </div>
    </div>
  </form>
</div>
